const walletParams = {
  hitType: 'event',
  eventCategory: 'Wallet',
  eventAction: 'connect',
  userAgent: window.navigator.userAgent,
}

const mintParams = {
  hitType: 'event',
  eventCategory: 'nft',
  eventAction: 'click',
  eventLabel: 'nft',
  userAgent: window.navigator.userAgent,
}

const gotchiParams = {
  hitType: 'event',
  eventCategory: 'VvsGotchi',
  userAgent: window.navigator.userAgent,
}

export const walletConnect = (walletName: string) => {
  window.gtag('event', 'wallet', {
    ...walletParams,
    eventLabel: walletName,
  })
}

export const walletConnected = (walletName: string) => {
  window.gtag('event', 'wallet_connected', {
    ...walletParams,
    eventLabel: walletName,
  })
}

export const nftMoleMintEntranceClicked = () => {
  window.gtag('event', 'nft_mole_mint_click', mintParams)
}

export const nftMoleEnableTransaction = () => {
  window.gtag('event', 'nft_mole_enable_transaction', mintParams)
}

export const nftMoleEnabledAndNext = () => {
  window.gtag('event', 'nft_mole_enabled_next', mintParams)
}

export const nftMoleConfirmMint = () => {
  window.gtag('event', 'nft_mole_confirm_mint', mintParams)
}

export const gotchiOpenGachaponModal = () => {
  window.gtag('event', 'gotchi_open_gachapon_modal', gotchiParams)
}

export const gotchiOpenLeaderboard = () => {
  window.gtag('event', 'gotchi_open_leaderboard', gotchiParams)
}

export const gotchiMoleDashStartGame = () => {
  window.gtag('event', 'gotchi_mole_dash_start_game', gotchiParams)
}

export const gotchiMoleDashGameOver = (lastedMs: number) => {
  window.gtag('event', 'gotchi_mole_dash_game_over', {
    ...gotchiParams,
    lastedMs,
  })
}

export const gotchiGachaponDraw = (drawOption: string) => {
  window.gtag('event', 'gotchi_gachapon_draw', {
    ...gotchiParams,
    drawOption,
  })
}

export const gotchiFeedAction = (foodName: string) => {
  window.gtag('event', 'gotchi_feed_action', {
    ...gotchiParams,
    foodName,
  })
}

export const gotchiCleanAction = () => {
  window.gtag('event', 'gotchi_clean_action', gotchiParams)
}

export const gotchiAdoptActionBtnClick = () => {
  window.gtag('event', 'gotchi_adopt_action_btn_click', gotchiParams)
}

export const gotchiTeamUpActionBtnClick = () => {
  window.gtag('event', 'gotchi_team_up_action_btn_click', gotchiParams)
}
